import React from "react";
import "../css/paysuccess.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";

const PaySuccess = () => {
  const successful = new URLSearchParams(window.location.search).get("state") !== "cancel";
  return (
    <>
      <div className="successDiv">
        <div className="success-container">
          <div className="modal-content">
            <div className={`checkmark-circle ${successful ? "" : "cancelled"}`}>
              <FontAwesomeIcon icon={successful ? faCheck : faXmark} />
              <div className="checkmark"></div>
            </div>
            <h2>{successful ? "Payment submitted" : "Payment cancelled"}</h2>
            <p>{successful ? "Your order is being reviewed. A confirmation will be sent to your email." : "No payment was completed. Your cart remains available if you would like to try again."}</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default PaySuccess;
